import styled, { css, createGlobalStyle } from 'styled-components';
import isNull from 'lodash/isNull';
import { WORKSPACE_TOPBAR_HEIGHT, EDITOR_SIDEBAR_WIDTH } from 'common/styles/variables';

const touchpointEditorCss = css`
    display: grid;
    grid-template-columns: 1fr ${EDITOR_SIDEBAR_WIDTH};
    height: calc(100vh - ${WORKSPACE_TOPBAR_HEIGHT});
`;

const guestExperienceEditorCss = css`
    overflow: auto;
    height: 100%;
`;

const activeEditorElementOutline = css`
    ${({ theme }) => `
        outline: 2px solid ${theme.palette.primary.main};
    `}
    outline-offset: -2px;
`;

export const FOCUS_CSS = css`
    /* &:focus-visible, &:focus  {
        cursor: text;
    } */

    outline-style: none;

    & > span {
        display: inline-block;
        min-width: 2rem;
    }

    & > span:focus,
    & > span:focus-visible {
        cursor: text;
        outline-style: none;
    }
`;

export const HIGHLIGHT_AND_CONTENT_EDITING_BEHAVIOR_CSS = css`
    ${FOCUS_CSS}
    ${({ selected, hovered }) => (selected || hovered ? activeEditorElementOutline : '')}
`;

export const BORDER_PROPERTIES = css`
    ${(props) => Object.entries(props.$borderWidth).map(([side, value]) => `border-${side}-width: ${value}px;`)};
    border-color: ${(props) => props.$borderColor};
    border-radius: ${(props) => props.$borderRadius}px;
`;

export const PADDING_PROPERTIES = css`
    padding-top: ${({ $padding }) => $padding.top}px;
    padding-bottom: ${({ $padding }) => (!isNull($padding.bottom) ? $padding.bottom : $padding.top)}px;

    padding-left: ${({ $padding }) => $padding.left}px;
    padding-right: ${({ $padding }) => (!isNull($padding.right) ? $padding.right : $padding.left)}px;
`;

export const ALIGNMENT_PROPERTIES = css`
    align-items: ${(props) => props.$perpendicularDirection};
    justify-content: ${(props) => props.$mainDirection};
    flex-direction: ${(props) => props.$direction};
`;

export const FONT_PROPERTIES = css`
    color: ${(props) => props.$fontColor};
    font-size: ${(props) => props.$fontSize}px;
    font-family: '${(props) => props.$fontFamily}', sans-serif;
`;

export const BACKGROUND_PROPERTIES = css`
    background-color: ${(props) => props.$backgroundColor};
    background-image: url(${(props) => props.$backgroundImageUrl});
    background-size: cover;
    background-position: center center;
`;

export const GuestExperienceContainer = styled.main`
    position: relative;
    ${(props) => (props.$editing || props.$previewing ? guestExperienceEditorCss : '')};
`;

export const SmoothScrollBehavior = createGlobalStyle`
    html {
        scroll-behavior: smooth;
    }
`;

export const SmoothPropertyAnimation = createGlobalStyle`
    ${GuestExperienceContainer} * {
        transition: ease 200ms;
        transition-property: padding, gap;
    }
`;

export const BlockContentContainer = styled.div`
    width: 100%;
    font-size: 1.25rem;
    text-align: center;
`;

const TouchpointContainer = styled.div`
    width: 100%;
    height: 100%;
    ${(props) => (props.editing ? touchpointEditorCss : '')};
`;

export const ScreenReaderSpan = styled.span`
    position: absolute;
    left: -10000px;
    top: auto;
    width: 1px;
    height: 1px;
    overflow: hidden;
`;

export const LoadingSpinnerContainer = styled.div`
    display: flex;
    height: 100vh;
    align-items: center;
    justify-content: center;
`;

export default TouchpointContainer;
